import s from './QuestionMarkIcon.module.scss';

const QuestionMarkIcon = () => (
  <div className={s.questionMark}>
    <span>?</span>
  </div>
);

export default QuestionMarkIcon;
